module.exports = __webpack_public_path__ + "static/media/loading3.5824bc1e.gif";